export default __webpack_public_path__ + "static/media/union-minus.4e78df7e.svg";